import { Link } from "react-router-dom";
import { CurrencyBitcoin } from "tabler-icons-react";
import { Card, Group, Stack, Title } from "@mantine/core";

import { BingoBreadcrumbs } from "bingo/components/BingoBreadcrumbs";
import { ADMIN_NAV_BINGO_GAMES, ADMIN_NAV_BINGO_TEMPLATES } from "_constants";
import { ADMIN_BINGO_GAMES_PATH, ADMIN_BINGO_TEMPLATES_PATH } from "_urls";

export function BingoMainAdminView() {
  return (
    <Stack className="h-full" my="xs">
      <Title order={3} align={"center"} m={"xs"}>
        Bingo Admin
      </Title>
      <BingoBreadcrumbs />
      <Link to={`${ADMIN_BINGO_TEMPLATES_PATH}`} className="no-underline">
        <Card style={{ flex: 1 }}>
          <Group spacing="xl">
            <CurrencyBitcoin size={50} />
            <Title order={3}>{ADMIN_NAV_BINGO_TEMPLATES}</Title>
          </Group>
        </Card>
      </Link>
      <Link to={`${ADMIN_BINGO_GAMES_PATH}`} className="no-underline">
        <Card style={{ flex: 1 }}>
          <Group spacing="xl">
            <CurrencyBitcoin size={50} />
            <Title order={3}>{ADMIN_NAV_BINGO_GAMES}</Title>
          </Group>
        </Card>
      </Link>
    </Stack>
  );
}
